import { ISurvey } from "../common/data/dtos/survey";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/Survey';

interface SurveyResponse {
    success: boolean;
    survey?: ISurvey;
    surveys?: ISurvey[];
    error?: string;
}

type CreateSurveyType = Omit<ISurvey, 'id'> | Partial<ISurvey>;

const createSurvey = async (survey: CreateSurveyType): Promise<SurveyResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ISurvey>(`${BASE_PATH}`, survey);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteSurvey = async (id: string): Promise<SurveyResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ISurvey>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getSurveys= async (): Promise<SurveyResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurvey>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, surveys: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneSurvey = async (id: string): Promise<SurveyResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ISurvey>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, survey: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateSurvey = async (survey: ISurvey): Promise<SurveyResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ISurvey>(`${BASE_PATH}/${survey.id}`, survey);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createSurvey,
    deleteSurvey,
    getSurveys,
    getOneSurvey,
    updateSurvey,
};